'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TextInput = require('../TextInput');

var _TextInput2 = _interopRequireDefault(_TextInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/** Specialized version of [TextInput](/components/TextInput) that masks and validates postal codes. */
var PostalCodeInput = function (_React$Component) {
  _inherits(PostalCodeInput, _React$Component);

  function PostalCodeInput() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, PostalCodeInput);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PostalCodeInput.__proto__ || Object.getPrototypeOf(PostalCodeInput)).call.apply(_ref, [this].concat(args))), _this), _this.mask = {
      CA: [/[a-zA-Z]/, /\d/, /[a-zA-Z]/, ' ', /\d/, /[a-zA-Z]/, /\d/],
      US: [/[1-9]/, /\d/, /\d/, /\d/, /\d/],
      'US+4': [/[1-9]/, /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/]
    }, _this.maskedMaxLength = {
      CA: 7,
      US: 5,
      'US+4': 10
    }, _this.maskingRules = {
      guide: true,
      mask: _this.mask[_this.props.country],
      unmask: ['_'],
      maskedMaxLength: _this.maskedMaxLength[_this.props.country]
    }, _this.getWarning = function (label, value) {
      return _this.validationRules(label, value, 'warning');
    }, _this.getError = function (label, value) {
      return _this.validationRules(label, value, 'error');
    }, _this.validationRules = function (label, value, type) {
      var country = _this.props.country;

      var message = {
        error: label + ' is Invalid',
        warning: 'Received Invalid ' + label
      };

      if (!value) {
        return '';
      } else if (country === 'US' && !_this.isValidUSPostalCode(value)) {
        return message[type];
      } else if (country === 'US+4' && !_this.isValidUSPlus4PostalCode(value)) {
        return message[type];
      } else if (country === 'CA' && !_this.isValidCAPostalCode(value)) {
        return message[type];
      } else {
        return '';
      }
    }, _this.isValidUSPostalCode = function (value) {
      var regex = /^[1-9]{1}\d{4}$/;
      return regex.test(value);
    }, _this.isValidUSPlus4PostalCode = function (value) {
      var regex = /^[1-9]{1}\d{4}([ ]?)\d{4}$/;
      return regex.test(value);
    }, _this.isValidCAPostalCode = function (value) {
      var regex = /^[A-Za-z]\d[A-Za-z][ ]?\d[A-Za-z]\d$/;
      return regex.test(value);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  // Since our error and warning rules are identical, we can centralize them with this function.


  _createClass(PostalCodeInput, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          props = _objectWithoutProperties(_props, ['children']);

      return _react2.default.createElement(
        _TextInput2.default,
        Object.assign({
          masking: this.maskingRules,
          getError: this.getError,
          getWarning: this.getWarning,
          maxLength: this.maskingRules.maskedMaxLength
        }, props),
        children
      );
    }
  }]);

  return PostalCodeInput;
}(_react2.default.Component);

PostalCodeInput.propTypes = {
  /** Any children to be passed through. */
  children: _propTypes2.default.node,

  /** Additional class name. */
  className: _propTypes2.default.string,

  /** Country code for masking. Enter 'CA' for Canada, 'US' for US zip, or 'US+4' for US zip + 4. */
  country: _propTypes2.default.string,

  /** Set to true to disable the PostalCodeInput. */
  disabled: _propTypes2.default.bool,

  /** Display label if set to true. */
  displayLabel: _propTypes2.default.bool,

  /** String to display as error. Overrides standard error and warning handling. */
  error: _propTypes2.default.string,

  /** Globally unique and descriptive HTML ID. Used by QA for automated testing. */
  htmlId: _propTypes2.default.string.isRequired,

  /** Input label. */
  label: _propTypes2.default.string.isRequired,

  /** Input name. */
  name: _propTypes2.default.string.isRequired,

  /** onChange callback. Called with `cb(event, isValid)`. Check isValid to determine if the control is in error. */
  onChange: _propTypes2.default.func.isRequired,

  /** Placeholder to display when the field is empty. Defaults to "Enter &lt;label&gt;" when a placeholder isn't provided. Example: If the label is set to "Zip", the placeholder will default to "Enter Zip".  */
  placeholder: _propTypes2.default.string,

  /** Mark label with asterisk and perform
   * required field validation on blur if set to true. */
  required: _propTypes2.default.bool,

  /** Text input value. */
  value: _propTypes2.default.string.isRequired,

  /** String to display as warning. Overrides standard error and warning handling. */
  warning: _propTypes2.default.string
};
PostalCodeInput.defaultProps = {
  country: 'US'
};
exports.default = PostalCodeInput;


//////////////////
// WEBPACK FOOTER
// ../fusion-ui-components/lib/PostalCodeInput/PostalCodeInput.js
// module id = 433
// module chunks = 2